import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { FlexItem } from '../../../Flex';
import AppLayoutRow from '../../AppLayoutRow';

import { getClassNames } from './HeaderRow.styles.legacy';
import type { HeaderRowProps } from './HeaderRow.types';

const HeaderRow: FC<PropsWithChildren<HeaderRowProps>> = ({ children, backgroundColor, depth = 'depth4' }) => {
  const classNames = getClassNames(depth, backgroundColor);

  if (!children) {
    return null;
  }

  return (
    <AppLayoutRow role="banner" zIndex={4} layoutRegion="app-header">
      <FlexItem grow={1} className={classNames.header}>
        {children}
      </FlexItem>
    </AppLayoutRow>
  );
};
export default HeaderRow;
